
import Component from 'vue-class-component'
import moduleStore from './store/fileExtract';
import Vue from 'vue';
import PageState from './store/state';
import { Toast, Dialog } from "vant"
import audioBufferToWav from 'audiobuffer-to-wav'
// import { getMediaFileDuration } from '../../utils/file'
import { Watch } from "vue-property-decorator"
import LZString from '../../utils/lz-string.min'
import Axios from "axios"
import { VanToast } from "vant/types/toast"
// import javaHost from '@/bin/javaSetting';
import { judgeDeviceType } from "@/utils/device";
import { getQueryString } from "@/utils/location";
// import {deserialize} from "v8";
import { crawlerHost } from "@/bin/javaSetting";
import { customCollectEvent } from '@/utils/collect';
// import {deserialize} from "v8";
const toWavUrl = `${crawlerHost}/extract`
// import $ from "jquery"
// const videourl = 'http://v6-default.ixigua.com/487096d31ef80a3663b3f55f79c85ab4/6278c0c4/video/tos/cn/tos-cn-ve-15c001-alinc2/937a1c06d3e04e66ab30beb3b6c201b2/?a=2011&ch=0&cr=0&dr=0&er=0&lr=unwatermarked&net=5&cd=0%7C0%7C0%7C0&cv=1&br=3754&bt=3754&cs=0&ds=4&ft=b_XF_mmnPkC2Xt7HhWwUx5GircHC~KVNsAuIn&mime_type=video_mp4&qs=0&rc=NzhmZDM1aTpoZTs5ZmZoPEBpanA0Zmg6ZjlsPDMzNGkzM0AyLzA1YF9eNTExYzEtYS8uYSNoLS9rcjRnc25gLS1kLS9zcw%3D%3D&l=202205091413540102080160881A80F24A#alapi'
/**components**/
@Component({})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class fileExtractPage extends Vue {
	state = new PageState();
	self: Vue = this;
	upType: string = '';
	activeIcon = require('./image/icon_close.png');
	inactiveIcon = require('./image/icon_finish.svg');
	videoEle: any = "";
	videoFile: any = "";
	canExtract: boolean = false;//控制开始提取按钮
	videoSize: any = 0;
	videoDuration: any = 0;
	isSubmiting = false;//提取中
	complete = 0;
	isCreating = false;
	videoName: string = "";
	videoUrl: string = "";
	dialect: string = "0";
	showResult: boolean = false;
	articleResult: any = {};
	articleResultText: string = "";
	copyText: string = "";
	toast: VanToast;
	videoFileName: string = '';
	isToWav: boolean = false;
	sampleRate: number = 0; // 采样率
	processUpload: string = '';
	loadingText: string = '';
	extractData: any = {};//提取出的视频信息
	dialogVisible: boolean = false;
	videoLinkLoading: boolean = false;//正在解析链接
	isFree: boolean = true; //免费模式
	vipPermission: number = 2;//vip类型
	extractText: string = '开始提取';
	videoFullName: string = '';//视频原名称
	userDuration: number = 0;//用户可用时长
	isIOS = judgeDeviceType.isIOS;
	showWarnningTip: boolean = false
	imageTextTitle: string = ""
	messageShow: boolean = false
	msgContent: string = ""
	iosAuthorization: Boolean = false
	stepObj = {}
	//结果循环请求次数
	getResultCount:number = 0
	// progressWidth:number = 0

	// canIosBuyVoice:boolean = false;
	// showBuyWindow:boolean = false;
	// currentBuyDurationItem:object = {};
	// paidList:object =[];
	// showBtn:boolean = true;
	height: number = 0;
	isAPP = judgeDeviceType.isAPP;
	placeHolderTxt: string = '支持几十家视频平台分享复制的链接';
	appVersion: string = '';//ios功能隐藏接口需要 -传appVersion 文件提取显示 不传隐藏
	functionList: any = [{ // 功能id
		name: 'link',
		functionName: '视频链接提取',
		switchStatus: false// true展示，false隐藏
	},
	{
		name: 'video',
		functionName: '视频文件提取',
		switchStatus: false
	}];
	appId: any = 100000;//默认嵌入的app是ios
	@Watch("videoUrl")
	changeCanExtract() {
		this.canExtract = this.videoUrl.trim() ? true : false;
	}
	@Watch("$route")
	watchRouteParamChange() {
		let _self = this;
		if (this.$route.query.copyText) {
			this.copyText = LZString.decompressFromBase64(this.$route.query.copyText as string);
		}
		//d3d3LmJhaWR1LmNvbQ%3D%3D
		// this.copyText = LZString.decompressFromBase64('d3d3LmJhaWR1LmNvbQ%3D%3D');
		this.state.title = "文案提取"
		document.title = "文案提取"
		if (this.showResult) {
			window.taroRawSdk.miniProgram.navigateBack();
		}
		if (this.isSubmiting) {
			Dialog.confirm({
				title: '是否退出当前页面',
				message: '视频正在上传，退出后文案提取将失败，请谨慎操作',
				confirmButtonColor: '#EA4036',
				confirmButtonText: '退出',
				cancelButtonColor: '#EBEBEB',
				cancelButtonText: '取消',
				className: 'warn-dialog',
			})
				.then(() => {
					// on confirm
					console.log('---upType', _self.upType)
				})
				.catch(() => {
					// on cancel
					console.log('---upType', _self.upType)
				});
		}
	}
	// activeIcon = require("./images/icon_mute_round_nor.png")
	// inactiveIcon = require("./images/icon_mute_round_sel.png")
	created(moduleData: IinjectDatas) {
		// this.vipPermission = this.vipInfo.types
		this.state = <PageState>moduleData.state;
		let ww_token = getQueryString("ww_token");
        let wwid = getQueryString("wwid");
		let source = getQueryString('source');
		this.upType = getQueryString('upType') || 'link';

		let appVersion = getQueryString('appVersion');
		if (ww_token) {
			this.state.ww_token = ww_token;
			// this.getWwid()
		}
        if(wwid){
            localStorage.setItem('wwid',wwid)
        }
		this.state.source = source || '';
		if (this.isAPP) {
			this.appId = 100000;//ios
		} else {
			// this.upType = 'link';
		}
		this.appVersion = appVersion || '';

		if (this.isAPP && appVersion) {
			this.getFunctionListFn(appVersion, this.appId);
		} else {//非ios app
			this.functionList = [{ // 功能id
				name: 'link',
				functionName: '视频链接提取',// true展示，false隐藏
				switchStatus: true
			},
			{
				name: 'video',
				functionName: '视频文件提取',
				switchStatus: true
			}]
			// this.upType = 'link';//只传入soruce 不传appVersion
		}
		// this.getIfFree();
		// this.getDurationPackage();
		// this.extractHost = process.env.NODE_ENV == 'production' ? 'https://edge-uc.ticwear.com' : 'https://edge-pre-uc.ticwear.com';


	}
	initState(){
		this.isCreating = false
		this.canExtract=true
		this.isSubmiting = false
		this.extractText = '文案提取'
		this.getResultCount = 0
	}
	getFunctionListFn(appVersion: string, appId: any) {
		let _this = this;
		this.$http("getFunctionList", { appVersion, appId }).then(res => {
			if (res.code == 200) {
				let funList = res.data;
				this.functionList = [];
				funList.map(item => {
					if (item.functionId == 2001) {
						item.functionName = '视频链接提取'
						item.name = 'link'
						if (!item.switchStatus) {
							_this.upType = 'video';
						} else {
							this.functionList.splice(0, 0, item);
							_this.upType = 'link';
						}
					}
					if (item.functionId == 2002) {
						item.functionName = '视频文件提取'
						item.name = 'video'
						if (item.switchStatus) {
							this.functionList.push(item);
						}
					}
				})
			}
		}).catch(() => {
			Toast('服务出错，请稍后再试')
		})
	}
	getIOSClipBordContent(message: string) {
		let copyText = LZString.decompressFromBase64(message);
		copyText = decodeURIComponent(copyText)
		if (copyText) {
			this.videoUrl = copyText;
		}
	}
	mounted(moduleData: IinjectDatas) {
		this.state.title = "文案提取"
		document.title = "文案提取"
		this.height = document.body.scrollHeight;
		(window as any).getIOSClipBordContent = this.getIOSClipBordContent;
		(window as any).isContinueUpload = this.isContinueUpload;
		let href = location.href;
		this.appVersion = getQueryString('appVersion');
		this.placeHolderTxt = this.isAPP ? '请输入视频链接' : '目前支持以下视频链接：抖音，快手，西瓜视频，火山，哔哩哔哩，腾讯视频，今日头条，皮皮虾，美拍，网易云，陌陌，映客，阳光宽频，最右，皮皮搞笑，vue vlog，轻视频，腾讯微视，QQ看点，视频时长限20分钟以内'
		if (this.isAPP) {
			let copyText = this.$route.query.copyText as string;
			copyText = copyText ? copyText.replace(/ /g, "+") : '';
			copyText = LZString.decompressFromBase64(copyText);
			if (copyText) {
				this.videoUrl = copyText;
			}
		} else {
			if (this.$route.query.copyText) {
				this.copyText = decodeURIComponent(this.$route.query.copyText as string);
				if (!this.videoUrl) {
					this.videoUrl = this.copyText;
				}
			}
		}
		if (getQueryString("ww_token")) {
			this.state.ww_token = getQueryString("ww_token")
			this._getUserVipInfo().then((res: any) => {
				this.vipPermission = res.type;
				// this.vipPermission = 2;
			})
		}

		//切换是否免费测试代码
		// let isFree = getQueryString("isFree");
		// this.isFree = isFree=='false'?false:true;
		this.state.self = this;
		// this.getUserDuration();


	}
	beforeDestroy() {
		this.isCancel = true;
	}
	// 获取登录用户的vip状态
	_getUserVipInfo() {
		let vm = this
		return new Promise((resolve, reject) => {
			this.$http("getVipInfo").then((res) => {
				if (res.code == 200) {
					vm.state.vipInfo = res.data
					resolve(res.data)
				} else if (res.code == 150004) {
					const { message } = res//TODO
					Toast(message)
					setTimeout(() => vm.gotoLogin(), 1500)
					reject()
				} else {
					reject()
				}
			}).catch(err => {
				let errTxt
				const response = err.response
				if (response && response.data) {
					const { message } = response.data
					if (message == "Required String parameter 'wwid' is not present") {
						errTxt = '登录已过期,请重新登录'
						Toast(errTxt)
						setTimeout(() => vm.gotoLogin(), 1500)
					} else if (errTxt && errTxt != "Required String parameter 'wwid' is not present") {
						Toast(errTxt || '服务出错，code1200')
					}
				}
			})
		})
	}
	closeDialog() {
		this.showWarnningTip = false
	}

	chooseVideo() {
		this.videoEle = this.$refs.uploadInput;
		// setTimeout(()=>{
		this.videoEle.click();
		// },500)
	}
	changeVideoUrl() {
		if (!this.canExtract && this.videoUrl) {
			this.canExtract = true;
		}
	}
	choosedVideo(e) {
		let file = e.target.files[0];
		e.target.value = '';
		let videoType = file.name.slice(file.name.lastIndexOf('.') + 1).toLocaleUpperCase();
		console.log('文件', file);

		// 由于在ios低版本下input上传mp4会自动转成mov，所以还需要判断一下mov
		if (videoType != "MP4" && videoType != 'MOV') {
			// Toast('请上传MP4格式的文件')
			this.messageShow = true
			this.msgContent = '请上传MP4格式的视频'
			return;
		}
		this.videoFullName = file.name;//文件全称
		// this.initVideoSize = file.size;//文件初始大小
		// let isLimit;
		let fileSize = file.size / 1024 / 1024;
		this.videoSize = fileSize.toFixed(2);
		// if (videoType == 'MP4' || videoType == 'MOV') {
		// 	isLimit = file.size / 1024 / 1024 > 300;
		// }

		// if (isLimit) {
		// 	Toast('请上传300M以内的视频文件')
		// 	return;
		// }
		//限制时长
		// this.videoDuration = 0
		// 	this.videoDuration = (res as number / 60).toFixed(2);
		// })
		//视频转音频
		let resultName = file.name.slice(0, file.name.lastIndexOf('.'))
		this.videoName = resultName;
		this.videoFile = file;
		let blobVideo = new Blob([file], { type: file.type })
		console.log('blobVideo', blobVideo)
		this.extractAudioFromVideo(blobVideo, file.name).then((wav) => {
			this.videoFile = wav
			this.toast.clear()
			this.canExtract = true
			this.isToWav = false
		}, (rej) => {
			this.canExtract = true
			if (rej == 'oversize') {
				this.toast.clear()
				// Toast('请上传20分钟内的视频文件')
				this.messageShow = true
				this.msgContent = '请上传20分钟以内的文件'
			} else if (rej == 'decode:fail') {
				this.isToWav = true
				if (judgeDeviceType.isIOS && judgeDeviceType.isWxBrowser) {
					window.WeixinJSBridge.invoke('getNetworkType', {}, e => {
						this.getVideoDuration(file)
					})
				} else {
					this.getVideoDuration(file)
				}
			}
		})
	}
	/**
	 * 获取视频时长
	 * @param file
	 */
	getVideoDuration(file: File) {
		window.URL = window.URL || window.webkitURL
		let audio = document.createElement('audio');
		audio.preload = 'metadata';
		let self = this
		// video.src = URL.createObjectURL(file)
		audio.src = URL.createObjectURL(file);

		if (judgeDeviceType.isIOS && !judgeDeviceType.isWxBrowser) {
			audio.muted = true;
			audio.play().then(() => audio.pause())
		}
		audio.addEventListener('loadedmetadata', function () {
			window.URL.revokeObjectURL(audio.src)
			let duration = parseInt(audio.duration + '')
			if (duration / 60 > 20) {
				self.messageShow = true
				self.msgContent = '请上传20分钟内的视频文件'
				return;
			}
			self.videoDuration = duration
			self.canExtract = true
			self.videoFile = file
			self.toast.clear()
		})
	}
	//显示提取清单
	toExtractList() {
		if (this.upType == "link") {
			this.getExtractData()
		} else {
			// this.getUserDuration()//获取用户剩余可用时长
			this.getFileExtractData()
		}
	}
	gotoLogin() {
		let type = this.upType == 'link' ? 'extractLink' : 'extractVideo'
		let path = encodeURIComponent(`/pages/webview/webview?from=tool&type=${type}&url=${location.href}&nav=${'文案提取'}`)
		this.$navigateTo({ url: `/pages/login/login?redirect=${path}` })
	}
	//视频链接提取清单
	getExtractData() {
		let vm = this;
		if (!this.state.ww_token) {
			this.canExtract = true;
			setTimeout(() => vm.gotoLogin(), 1500)
			return;
		}
		let postData = {
			videoUrl: this.videoUrl,
			source: this.state.source || 'MINI_PROGRAM'
			//   source:'MINI_PROGRAM'
		}
		this.isCreating = true//解析中...
		this.videoLinkLoading = true//正在解析链接
		this.canExtract = false//不可提取
		this.$http("postAchieveSubtitleVideoInfo", {body:postData}).then(res => {
			this.isCreating = false
			this.videoLinkLoading = false
			if (res.status == 150004) {
				Toast(res.message)
				this.canExtract = true;
				setTimeout(() => vm.gotoLogin(), 1500)
				return;
			} else if (res.code !== 200) {
				if (res.code == 154005 || res.code == 154007) {
					this.canExtract = true//可提取
					this.showWarnningTip = true
					this.imageTextTitle = res.message
				} else {
					this.canExtract = true//可提取
					this.messageShow = true
					this.msgContent = res.message
				}
				// Toast(res.data.message || '解析失败，请稍后重试')
				return
			}
			//   res.data.data.availableDuration=0;//测试时长不足（test)
			this.extractData = res.data
			// this.extractData.duration = 0
			// getMediaFileDuration({type: 'video'}, videourl).then(res =>{
			// 	console.log('getMediaFileDuration', res)
			// 	if (res) {
			// 		this.extractData.duration = res as number * 1000
			// 	}
			// })
			this.dialogVisible = true
			//弹窗上下居中
			this.$nextTick(() => {
				let dialogH = document.querySelector('.dialog-content').scrollHeight;
				let listDiaEle = document.querySelector('.list-dialog') as any;
				listDiaEle && (listDiaEle.style.top = ((this.height - dialogH) / 2) + 'px');
			})
			this.canExtract = true;
		}).catch(() => {
			// Toast('解析失败，请稍后重试')
			this.messageShow = true
			this.msgContent = '解析失败，请稍后重试'
			this.isCreating = false
			this.videoLinkLoading = false
		})
	}
	//视频文件提取清单
	getFileExtractData() {
		let vm = this;
		//校验token
		if (!this.state.ww_token) {
			this.dialogVisible = false;
			this.canExtract = true;
			setTimeout(() => vm.gotoLogin(), 1500)
			return;
		}
		this.startFileExtract()
		

	}
	//文件提取
	startFileExtract() {
		if (!this.videoFile) {
			// Toast("文件不存在，请重新上传")
			this.messageShow = true
			this.msgContent = '文件不存在，请重新上传'
			return
		}
		this.extractData = {
			title: this.videoFullName,
			duration: this.videoDuration * 1000,
			length: this.videoSize * 1024 * 1024,
			availableDuration: this.userDuration,
			videoFileType: 'video' // 用来标识是视频链接还是上传文件
		}
		if (this.vipPermission == 2) {
			this.dialogVisible = true;
			this.canExtract = false;
			this.$nextTick(() => {
				let dialogH = document.querySelector('.dialog-content').scrollHeight;
				let listDiaEle = document.querySelector('.list-dialog') as any;
				listDiaEle && (listDiaEle.style.top = ((this.height - dialogH) / 2) + 'px');
			})
			return;

		}
		this.onSubmit()
	}
	secondToDate(time, type) { // type 单位是秒 其他是毫秒
		if (time === 0) {
			return '0分钟'
		} else {
			time = type ? time : time / 1000
			let h = Math.floor(time / 3600)
			let m = Math.floor((time / 60 % 60))
			let s = Math.floor((time % 60))
			return (h && (h + "小时") || '') + (m && (m + "分钟") || '') + (s && (s + "秒") || '')
		}
	}
	getTextContent() {
		this._getUserVipInfo().then(() => {
			this.dialogVisible = false;
			if (this.upType == "link") {
				this.onUrlSubmit()
			} else {
				this.onSubmit()
			}
		})
	}
	//续费会员
	goToBuy() {
		if (window.platformSource == 'app') {
			let switchToVipPage: any = (<any>window).switchToVipPage
			switchToVipPage.postMessage("")
		}else if (this.isFree) {//免费模式-开通|续费会员
			this.$navigateTo({
				url: `/pages/recharge-vip/recharge-vip?fromBtn=fileExtract`,
			})
		} else {//收费模式-时长续费
			this.$navigateTo({
				url: "/pages/buy-durations/buy-durations",
			})
		}
	}
	onUrlSubmit() {
		let param = {
			videoUrl: this.videoUrl,
			title: this.extractData.title,
			duration: Math.ceil(this.extractData.duration/1000)+"",
			length: this.extractData.length,
			videoId: this.extractData.videoId,
			dialect: this.dialect,
			source: 'MINI_PROGRAM'
		}
		this.isCreating = true
		this.showResult = false
		this.isSubmiting = true
		window.taroRawSdk.miniProgram.postMessage({ data: { isSubmiting: true } })
		this.loadingText = '提取中ing'
		// 埋点
		let pointData = {
			type1: '视频',
			type2: '链接',
			source: 'wx',
            'user_id':localStorage.getItem("wwid")||''
		}
		this.$http("postExtract",{body:param} ).then((res: any) => {
				if (res.code !== 200 || !res.data) {
					// Toast(res.data.message || '提取失败，请稍后再试或上传视频文件')

					this.messageShow = true
					this.msgContent = res.message
					this.initState()
					return
				}
				setTimeout(() => {
					this.getResult(res.data.taskId)
				}, 1000);
				// window.location.href =location.protocol+"//"+location.host+ "/#/extractResult?params="+JSON.stringify(resData)
			})
			.catch((err) => {
				Toast("服务出错，请稍后再试");
				this.initState()
				window.taroRawSdk.miniProgram.postMessage({ data: { isSubmiting: false } })
				this.complete = 0
			})
		customCollectEvent('words_start', pointData)
	}
	isCancel = false
	//取消任务
	async cancelTask(taskId) {
		try {
			await this.$http("deleteAsyncExtract", { taskId });
			Toast('任务已取消');
		} catch (err) {
			Toast('任务取消失败');
		}
	}
	
	//获取提取结果
	async getResult(taskId) {
		if (this.isCancel) {
			this.isCancel = false;
			await this.cancelTask(taskId);
			return;
		}
	
		try {
			const res = await this.$http("getAsyncResult", { taskId });
			const resData = res.data;
	
			if (resData.step==3) {
				this.extractText = '文案提取';
				this.articleResult = resData
				let articleResultText = resData.text.trim();
				this.articleResultText = articleResultText.startsWith("\n") ? articleResultText.substring(1) : articleResultText;
				this.showResult = true;
				this.initState();
				this.stepObj = {
					step: 4,
					rank: 0
				};
			} else if(resData.step == 0 || resData.step === 1||resData.step === 2) {
				let step = resData.step;
				let stepTextList = ["正在解析中",`视频同步中(${resData.description})`,`${resData.description}`,'文案提取','文案提取'];
				this.stepObj = {
					step: step,
					rank: resData.rank || 0
				};
				this.extractText = stepTextList[step];
				this.getResultCount++;
				let time = this.getResultCount < 3 ? 1000 : 3000;
				setTimeout(() => {
					this.getResult(taskId);
				}, time);
			}else{
				this.initState();
				this.msgContent = resData.message || '提取失败';
				this.messageShow = true;
				this.complete = 0;
				window.taroRawSdk.miniProgram.postMessage({ data: { isSubmiting: false } });
			}
		} catch (err) {
			this.complete = 0;
			this.initState();
			let errorMessage = err.message || '服务出错，请稍后再试';
			Toast(errorMessage);
			window.taroRawSdk.miniProgram.postMessage({ data: { isSubmiting: false } });
		}
	}
	//取消排队
	cancelExtract() {
		this.stepObj = {}
		this.isCancel = true
		this.initState()
		window.taroRawSdk.miniProgram.postMessage({ data: { isSubmiting: false } })
		this.complete = 0

	}
	//文件上传
	onSubmit() {
		if (!this.videoFile) {
			// Toast("文件不存在，请重新上传")
			this.messageShow = true
			this.msgContent = '文件不存在，请重新上传'
			return
		}
		// 埋点
		let pointData = {
			type1: '视频',
			type2: '文件',
			source: 'wx',
            'user_id':localStorage.getItem("wwid")||''
		}
		const formData = new FormData()
		formData.append("file", this.videoFile)
		formData.append("title", this.extractData.title)
		formData.append("length", this.extractData.length)
		formData.append("duration", parseInt(this.extractData.duration/1000+"")+"")
		this.isCreating = true
		this.isSubmiting = true
		window.taroRawSdk.miniProgram.postMessage({ data: { isSubmiting: true } })
		let uploadUrl = 'https://tts-files.mobvoi.com/v1/file/uploadToOss'
		// let uploadUrl = 'https://tc-nj-tts-files.mobvoi.com/v1/file/uploadToOss'
		if (this.isToWav) {
			uploadUrl = toWavUrl
		}
		Axios.post(uploadUrl, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
			onUploadProgress: progressEvent => {
				const loaded = progressEvent.loaded
				const total = progressEvent.total
				let loadedToM = (loaded / 1024 / 1024).toFixed(0)
				let totalToM = (total / 1024 / 1024).toFixed(0)
				// 计算上传速度和预计时间
				this.complete = ((loaded / total) * 100) | 0
				this.processUpload = loadedToM + 'M' + '/' + totalToM + 'M'
				// this.canExtract = false;
				this.extractText = '文件上传中'+ this.processUpload
				// this.loadingText = '上传中 ' + this.processUpload
				// if (loaded === total) {
				// 	this.loadingText = '提取中ing'
				// }
			},
			timeout: 1000 * 60 * 30 // 设置30分钟超时
		}).then(res => {
			console.log(res)
			if (res.status != 200 || res.data.code !== 200 || !res.data.data) {
				// Toast(res.data.message || '提取失败，请稍后再试')
				this.messageShow = true
				this.msgContent = res.data.message
				this.isCreating = false
				this.isSubmiting = false
				this.canExtract=true
				window.taroRawSdk.miniProgram.postMessage({ data: { isSubmiting: false } })
				return
			}
			if (this.isToWav && res.data.sample_rate) {
				this.sampleRate = res.data.sample_rate
			}
			// let extractFormData = new FormData();
			// extractFormData.append("videoName", this.videoFile.name)
			let duration = Number(this.videoDuration) > 0 ? this.videoDuration * 1000  : 0
			// extractFormData.append("duration", duration)
			// extractFormData.append("url", res.data.data)
			// extractFormData.append("source", "MINI_PROGRAM")
			let extractFormObj = {
				videoName: this.videoFile.name,
				duration: Math.ceil(duration/1000)+"",
				url: res.data.data,
				source: "MINI_PROGRAM",
				length: this.videoFile.size,
				dialect:'0',
				type: 2,
				videoUrl:''
			}
			this.loadingText = '提取中ing'
			this.$http("postExtract", {body:extractFormObj}).then((res: any) => {
					if (res.code !== 200 || !res.data) {
						this.messageShow = true
						this.msgContent = res.message
						this.initState()
						
						return
					}
					setTimeout(() => {
						this.getResult(res.data.taskId)
					},1000)
					// window.location.href =location.protocol+"//"+location.host+ "/#/extractResult?params="+JSON.stringify(resData)
				})
				.catch((err) => {
					Toast("服务出错，请稍后再试");
					this.initState()
					window.taroRawSdk.miniProgram.postMessage({ data: { isSubmiting: false } })
					this.complete = 0
				})
		}).catch((e) => {
			// this.$message.error("服务出错，请稍后再试")
			Toast("服务出错，请稍后再试");
			this.initState()
			window.taroRawSdk.miniProgram.postMessage({ data: { isSubmiting: false } })
			this.complete = 0
		})
		customCollectEvent('words_start', pointData)
	}

	extractAudioFromVideo(videoBlob, fileName) {
		this.toast = Toast.loading({
			icon: "none",
			message: "视频解析中...",
			forbidClick: true,
			duration: 0
		})
		let self = this
		let AudioContext1 = window.AudioContext || (window as any).webkitAudioContext;
		let audioContext = new AudioContext1()
		let reader = new FileReader()
		return new Promise((resolve, reject) => {
			reader.readAsArrayBuffer(videoBlob)//blob -> buffer
			reader.onload = function (e) {
				let videoFileAsBuffer: any = reader.result as ArrayBuffer
				audioContext
					.decodeAudioData(videoFileAsBuffer, (decodedData) => {
						fileName = fileName.slice(0, fileName.lastIndexOf('.')) + '.wav'
						let duration = decodedData.duration;
						console.log('###', decodedData)
						duration = parseInt(duration);
						self.videoDuration = duration;
						self.toast.clear()
						if (duration / 60 > 20) {
							reject('oversize');
						} else {
							let wav = audioBufferToWav(decodedData);
							let blob = new window.Blob([new DataView(wav)], {
								type: 'audio/wav'
							})
							let file = new File([blob], fileName, {
								type: 'audio/wav'
							})
							resolve(file)
						}
					}, err => {
						reject('decode:fail')
						console.log('转码出错', err)
					}).finally(() => {
						audioContext.close(); // 关闭AudioContext, 释放资源
						reader.abort(); // 中止读取操作, 释放资源
						self.toast.clear()
					  })
			}
		})
	}
	reChooseVideo() {
		if (this.isSubmiting) {
			return
		}
		let _self = this;
		Dialog.confirm({
			title: '是否重新选择视频',
			message: '重选会导致当前视频丢失',
			confirmButtonColor: '#EA4036',
			confirmButtonText: '重选',
			cancelButtonColor: '#EBEBEB',
			cancelButtonText: '取消',
			className: 'warn-dialog',
		})
			.then(() => {
				// on confirm
				_self.videoEle = _self.$refs.uploadInput;
				_self.videoEle.click();
			})
			.catch(() => {
				// on cancel
				console.log('---upType', _self.upType)
			});

	}
	clearVideo() {
		this.videoFile = "";
		this.videoName = "";
		this.videoSize = 0;
		this.videoDuration = 0;
		this.canExtract = false;

	}
	changeUpType(name: string) {
		let _self = this;
	}
	pasteUrl() {
		if(this.isSubmiting){
			return
		}
		if (this.isAPP) {
			let getClipBordContent: any = (<any>window).getClipBordContent
			//let param:string=JSON.stringify({'articleId':this.state.articleId,'audioLink':this.state.audioOssFile,'videoName':this.editor.textContent.slice(0,11)})
			getClipBordContent.postMessage("")
		} else {
			Toast("请点击输入框，长按粘贴内容")
		}
	}
	clearUrl() {
		if(!this.isSubmiting){
			this.videoUrl = "";
		}
	}
	goToIndex() {
		customCollectEvent('words_goeditor', {
			'button': '文案提取',
			'source': 'wx'
		})
		//校验token
		this.checkTokenCB()
	}
	checkTokenCB() {
		let vm = this;
		if (vm.articleResult) {
			localStorage.setItem('articleContent', vm.articleResultText)
		}
		let resultTxt = encodeURIComponent(LZString.compressToBase64(vm.articleResultText));
		let resultObj = { 'copyText': resultTxt };
		if (this.isAPP) {
			let switchToEditPage: any = (<any>window).switchToEditPage
			switchToEditPage.postMessage(JSON.stringify(resultObj))
		} else {
			vm.$navigateTo({
				url: "/pages/audition-web/audition-web?articleContent=true",
			})
		}
	}

	copyContent() {
		this.copyTextToClipboard(this.articleResult.text)
		customCollectEvent('words_copywords', {
			'button': '文案提取',
			'source': 'wx'
		})
	}
	copyTextToClipboard(text) {
		let textArea = document.createElement('textarea')
		textArea.setAttribute('readOnly', "readOnly");
		textArea.style.position = 'fixed';
		textArea.style.top = '0';
		textArea.style.left = '0';
		textArea.style.width = '2em';
		textArea.style.height = '2em';
		textArea.style.padding = '0';
		textArea.style.border = 'none';
		textArea.style.outline = 'none';
		textArea.style.boxShadow = 'none';
		textArea.style.background = 'transparent';
		textArea.value = text;

		document.body.appendChild(textArea);
		textArea.select()
		textArea.setSelectionRange(0, textArea.value.length)
		try {
			let msg = document.execCommand('copy') ? '成功' : '失败';
			Toast('复制成功')
		} catch (err) {
			Toast('该复制方案不可用')
		}
		document.body.removeChild(textArea)
	}
	
	beforeChooses(e) {
		let href = location.href;
		console.log('iosAuthorization1', this.iosAuthorization);
		if (this.isAPP && !this.iosAuthorization) {
			let iosAuthorization: any = (<any>window).iosAuthorization;
			e.preventDefault();
			//由你通知是否可以继续
			console.log('iosAuthorization', this.iosAuthorization);

			iosAuthorization.postMessage("haha")
		}
	}
	isContinueUpload() {
		this.iosAuthorization = true;
		(this.$refs.uploadInput as HTMLElement).click();
	}
}
